import React, {useEffect, useState} from 'react';

import {ThreeDots} from 'react-loader-spinner';
import {useNavigate} from 'react-router-dom';
import {useDispatch, useSelector, useStore} from 'react-redux';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {faCaravan} from '@fortawesome/free-solid-svg-icons'
import type {RootState} from "../Store";
import {selectCart} from "../redux/Cart";
import Loader from "../components/Loader";

const Home = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const data = useSelector((state: RootState) => state)

    const clickMe = (parameter: {'id': null,'code': '', 'name': '', 'price': 0 }) => () => {

        dispatch(selectCart(parameter));
        navigate('/cart/'+parameter.code);

    }

    if(data.cart.list.length === 1) {
        dispatch(selectCart(data.cart.list[0]));
        navigate('/cart/'+data.cart.list[0].code);
    }

    return (
        <div>

            {data.cart.list.map((cart: any, index: number) => {
                return (

                    <div key={index} onClick={clickMe(cart)}>

                        <FontAwesomeIcon icon={faCaravan} size="2xl"/>
                        {cart.name}

                        <hr/>

                    </div>

                );
            })}

            {data.cart.list.length == 0 &&
                <div className={"w-full"}>
                    <Loader/>
                </div>
            }
        </div>
    );


}

export default Home;
